<template>
  <div class="sport-preloader" v-if="isShowPreloader">
    <div class="preloaderStaticLogo">
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="29" viewBox="0 0 100 29" fill="none">
        <path
          d="M0 6.98274C0 3.51406 2.98524 0.702148 6.66773 0.702148H56.0089C59.6914 0.702148 62.6766 3.51407 62.6766 6.98274V22.1621C62.6766 25.6308 59.6914 28.4427 56.0089 28.4427H6.66773C2.98525 28.4427 0 25.6308 0 22.1621V6.98274Z"
          fill="#5ED028" />
        <path
          d="M8.81331 8.78809C9.88117 8.78809 10.5931 9.48101 10.7354 10.5092L12.5864 17.7066L14.8645 10.1292C15.0781 9.32454 15.8137 8.78809 16.7154 8.78809C17.6172 8.78809 18.3291 9.32454 18.5426 10.1292L20.8445 17.7066L22.6717 10.5092C22.8378 9.48101 23.5022 8.78809 24.5938 8.78809C25.8752 8.78809 26.3261 9.77159 25.8752 11.1351L22.7429 20.5901C22.5056 21.3501 21.7699 21.8418 20.9156 21.8418C20.0614 21.8418 19.3732 21.3501 19.1122 20.5901L16.7154 13.3703L14.295 20.5901C14.0577 21.3501 13.3458 21.8418 12.4677 21.8418C11.6372 21.8418 10.9253 21.3501 10.6643 20.5901L7.53189 11.1351C7.10475 9.77159 7.55562 8.78809 8.81331 8.78809Z"
          fill="white" />
        <path
          d="M35.6367 20.1983V10.4061C35.6367 9.42464 36.3395 8.7627 37.4057 8.7627C38.3508 8.7627 39.005 9.31051 39.1262 10.1322C40.1682 9.31051 41.5495 8.7627 43.1004 8.7627C46.4444 8.7627 48.8192 10.7485 48.8192 13.4648V20.1983C48.8192 21.1798 48.1407 21.8418 47.0503 21.8418C46.0083 21.8418 45.3055 21.1798 45.3055 20.1983V14.0582C45.3055 12.5061 44.0454 11.342 42.2764 11.342C40.4832 11.342 39.1504 12.5061 39.1504 14.0582V20.1983C39.1504 21.1798 38.4719 21.8418 37.3815 21.8418C36.3395 21.8418 35.6367 21.1798 35.6367 20.1983Z"
          fill="white" />
        <path
          d="M28.8955 20.1983V10.4061C28.8955 9.42464 29.574 8.7627 30.6645 8.7627C31.7065 8.7627 32.4092 9.42464 32.4092 10.4061V20.1983C32.4092 21.1798 31.7065 21.8418 30.6403 21.8418C29.5983 21.8418 28.8955 21.1798 28.8955 20.1983Z"
          fill="white" />
        <path
          d="M32.6461 5.55898C32.6461 6.59959 31.7506 7.44316 30.6458 7.44316C29.5411 7.44316 28.6455 6.59959 28.6455 5.55898C28.6455 4.51838 29.5411 3.6748 30.6458 3.6748C31.7506 3.6748 32.6461 4.51838 32.6461 5.55898Z"
          fill="white" />
        <path
          d="M52.6787 19.9665C52.6787 18.8914 53.553 18.0908 54.8643 18.0908C56.1028 18.0908 56.9771 18.8914 56.9771 19.9665C56.9771 21.0417 56.1028 21.8423 54.8643 21.8423C53.553 21.8423 52.6787 21.0417 52.6787 19.9665Z"
          fill="white" />
        <path
          d="M74.8122 13.8498C75.5511 14.0961 76.0836 14.4822 76.4098 15.0081C76.7426 15.5273 76.909 16.1896 76.909 16.9951C76.909 18.3198 76.5662 19.3216 75.8806 20.0006C75.195 20.6729 74.1332 21.009 72.6954 21.009H69.3504C68.9776 21.009 68.6914 20.9125 68.4917 20.7195C68.2987 20.5264 68.2021 20.2435 68.2021 19.8708V9.05703C68.2021 8.68426 68.2987 8.40468 68.4917 8.21829C68.6914 8.02525 68.9776 7.92873 69.3504 7.92873H72.276C73.614 7.92873 74.5992 8.20498 75.2316 8.75748C75.8706 9.30998 76.1901 10.1554 76.1901 11.2937C76.1901 12.4652 75.7308 13.3173 74.8122 13.8498ZM70.4987 13.1609H72.306C72.8385 13.1609 73.2312 13.0277 73.4842 12.7615C73.7438 12.4885 73.8736 12.1058 73.8736 11.6132C73.8736 11.1006 73.7438 10.7212 73.4842 10.4749C73.2312 10.2286 72.8285 10.1055 72.276 10.1055H70.4987V13.1609ZM72.5556 18.8323C73.2479 18.8323 73.7605 18.6726 74.0933 18.353C74.4328 18.0269 74.6025 17.5343 74.6025 16.8753C74.6025 16.3694 74.4328 15.9467 74.0933 15.6072C73.7605 15.2677 73.2712 15.0979 72.6255 15.0979H70.4987V18.8323H72.5556Z"
          fill="#1F93FF" />
        <path
          d="M93.2866 19.6304V10.1559H90.5114C89.8574 10.1559 89.4155 9.71401 89.4155 9.02464C89.4155 8.37062 89.8574 7.92871 90.5114 7.92871H98.8546C99.5086 7.92871 99.9505 8.37062 99.9505 9.05999C99.9505 9.71401 99.5086 10.1559 98.8546 10.1559H96.0794V19.6304C96.0794 20.4435 95.5315 21.0091 94.6653 21.0091C93.8522 21.0091 93.2866 20.4435 93.2866 19.6304Z"
          fill="#1F93FF" />
        <path
          d="M79.2592 19.4536V9.30746C79.2592 8.47667 79.8071 7.92871 80.6556 7.92871H86.1352C86.8069 7.92871 87.2488 8.37062 87.2488 9.05999C87.2488 9.71401 86.8069 10.1559 86.1352 10.1559H82.052V13.2493H85.9761C86.6302 13.2493 87.0897 13.6912 87.0897 14.3805C87.0897 15.0345 86.6302 15.4765 85.9761 15.4765H82.052V18.6051H86.1352C86.8069 18.6051 87.2488 19.047 87.2488 19.7187C87.2488 20.3904 86.8069 20.8323 86.1352 20.8323H80.6556C79.8248 20.8323 79.2592 20.2667 79.2592 19.4536Z"
          fill="#1F93FF" />
      </svg>
    </div>
    <div class="loading-text">{{ currentTitle }}</div>
    <div class="progress-bar">
      <div class="progress"></div>
    </div>
  </div>
</template>

<script setup>
  const { getContent } = useProjectMethods();
  const globalStore = useGlobalStore();
  const {
    layoutData,
    defaultLocaleLayoutData,
  } = storeToRefs(globalStore);

  const isShowPreloader = ref(true);
  const isSportBookLoaded = ref(false);
  const isProgressBarFinished = ref(false);
  const randomParts = ref([]);
  const progressWidth = ref(0);
  const progressWidthString = computed(() => `${progressWidth.value}%`);
  const preloadTitles = computed(() => getContent(layoutData.value, defaultLocaleLayoutData.value, 'preloader.sportPreloader.titles'));
  const currentTitle = ref(preloadTitles.value[0]);

  const getRandomNumber = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  const setUniqueRandomNumbers = (min, max, count) => {
    const uniqueNumbers = new Set();

    while (uniqueNumbers.size < count) {
      const randomNum = getRandomNumber(min, max);
      uniqueNumbers.add(randomNum);
    }

    randomParts.value = [...Array.from(uniqueNumbers).sort((a, b) => a - b), 95];
  };

  const renderProgress = () => {
    randomParts.value.forEach((part, index) => {
      setTimeout(() => {
        progressWidth.value = part;
        currentTitle.value = preloadTitles.value[index + 1] || currentTitle

        if (index === randomParts.value.length - 1) {
          isProgressBarFinished.value = true;
        }
      }, part * index * 4);
    })
  };

  const handleSBLoaded = () => {
    isSportBookLoaded.value = true;
  };

  defineExpose({ handleSBLoaded });

  onBeforeMount(() => {
    setUniqueRandomNumbers(0, 90, 4);
  });

  onMounted(async () => {
    await nextTick();

    renderProgress();
  });

  watch([isSportBookLoaded, isProgressBarFinished], ([newIsSportBookLoaded, newIsProgressBarFinished]) => {
    if (newIsSportBookLoaded && newIsProgressBarFinished) {
      setTimeout(() => {
        isShowPreloader.value = false;
      }, 500);
    }
  });
</script>


<style src="~/assets/styles/components/atomic/sport-preloader.scss" lang="scss" />

<style scoped lang="scss">
  .sport-preloader {
    --progressWidth: v-bind('progressWidthString');
  }
</style>
